import React, { useContext, useEffect } from 'react'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { post } from '../../Common/api'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import PublicContext from '../PublicContext'
import MobileSlotPage from './Mobile/MobileSlotPage'
import ComputerSlotPage from './Computer/ComputerSlotPage'
import TabletSlotPage from './Tablet/TabletSlotPage'
import { screenSize } from '../../Common/Common'
const { confirm } = Modal

export default function SlotPage () {
  const { slot, setSiderTitle, slotStatus, setSlot, updateStatus, setSiderDisabled } = useContext(PublicContext)
  const { t } = useTranslation()

  const onCancel = () => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: t('Public.ConfirmedSlot.modalConfirm'),
      onOk () {
        post({
          url: `public/slots/${slot.id}/cancel`,
          params: {},
          onSuccess: (json) => {
            setSlot(json)
            updateStatus(json)
          }
        })
      }
    })
  }

  const titles = {
    timeout: 'TimeoutSlotPage',
    cancel: 'CancelSlotPage',
    confirmed: 'ConfirmedSlotPage'
  }

  useEffect(() => {
    setSiderTitle(t(`Public.${titles[slotStatus]}.title`))
    setSiderDisabled(true)
  }, [slotStatus])

  const slotPage = {
    Mobile: MobileSlotPage,
    Computer: ComputerSlotPage,
    Tablet: TabletSlotPage
  }

  const ResponsivePage = slotPage[screenSize()]

  return (
    <>
      { slot && <ResponsivePage box={slot.box} slot={slot} onCancel={onCancel} slotStatus={slotStatus} /> }
    </>
  )
}
